import { LiveSupportMessage, TableMessage } from '../api';
import { Message } from '../store/slices/chat/types';

// TODO: move below to /components/chat/utils

export const LIVE_SUPPORT_WELCOME_MESSAGE: Message = {
  messageId: 'initial_support_chat_message',
  role: 'LIVE_SUPPORT',
  tagMessage: 'SUPPORT',
  content: 'LIVE_WELCOME',
  userId: 'support',
  userScreenName: 'LIVE_SUPPORT',
  requireTranslation: true,
  timestamp: Date.now(),
  showMessage: true,
};

export interface ParseType extends Message, LiveSupportMessage, TableMessage {}

export const parseChatMessage = <Type extends ParseType>(message: Type): Type => {
  message.showMessage = message.showHide;
  delete message.showHide;
  return message;
};
